import { type FC } from 'react';
import { useScrollContext } from '../ScrollContext';
import { CaptureInfoFormActionsStyled, DownArrow } from './CaptureInfoFormActions.styled';

export const CaptureInfoFormActions: FC = ({ children, ...props }) => {
    const { scrollState, ref } = useScrollContext();
    return (
        <CaptureInfoFormActionsStyled {...props} showShadow={!scrollState.scrolledToBottom}>
            {!scrollState.scrolledToBottom && <DownArrow onClick={() => ref.current?.scrollTo({ top: ref.current.scrollHeight })} />}
            {children}
        </CaptureInfoFormActionsStyled>
    );
};
